import { observer } from 'mobx-react'
import { FC } from 'react'
import { ICompanyBase } from '@/types'
import { CompanyCardWithJobHeaderContentLabel } from '@components-v2/molecules/CompanyCardWithJobHeaderContentLabel'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
}

export const CompanyCardWithJobHeaderContent: FC<Props> = observer(({ company }) => {
  return (
    <>
      <p className={styles.name}>{company.name}</p>
      <p className={styles.conceptPitch}>{company.conceptPitch}</p>
      <div className={styles.label}>
        <CompanyCardWithJobHeaderContentLabel company={company} />
      </div>
    </>
  )
})
